import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	FaRegUser,
	FaRegStar,
	FaEye,
	FaRegHeart,
	FaRegEye,
} from "react-icons/fa";
import { FiDroplet, FiMessageCircle } from "react-icons/fi";
import { GoFlame } from "react-icons/go";
import { TbCategory } from "react-icons/tb";
import SimpleWrapper from "../components/SimpleWrapper";
import {
	Card,
	ImageWrapper,
	BlogImage,
	StatsBar,
	Stat,
	Star,
	Description,
	CategoryIcon,
	CategoryRow,
	CategoryText,
	TitleOverlay,
	InfoRow,
	ProfileIcon,
	Author,
	Dot,
	DateText,
	HoverOverlay,
} from "./BlogCard.styled";
import BlogCarousel from "../components/BlogCarousel";
import BlogRightSidebar from "../components/BlogRightSideBar";

export default function BlogList() {
	const [blogs, setBlogs] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		fetch("/blogs.json")
			.then((res) => res.json())
			.then((data) => {
				const mapped = data.map((blog) => ({
					...blog,
					author: "Fine Labs Team",
					category: blog.tags[0] || "General",
				}));
				setBlogs(mapped);
			});
	}, []);

	return (
		<>
			<div className='mt-[60px] hidden md:block'>
				<BlogCarousel />
			</div>

			<SimpleWrapper searchVisible={false} navigation={false}>
				<div className='flex flex-col md:flex-row gap-8'>
					{/* LEFT: Blog Cards */}
					<div className='w-full md:w-2/3'>
						<div className='max-w-full py-10'>
							{/* Blog Cards Grid */}
							<div className='grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-start'>
								{blogs.map((blog) => {
									const dateObj = new Date(blog.date);
									const formattedDate = dateObj.toLocaleDateString("en-US", {
										year: "numeric",
										month: "long",
										day: "numeric",
									});

									return (
										<Card
											key={blog.slug}
											style={{ cursor: "pointer" }}
											onClick={() => navigate(`/blog/${blog.slug}`)}>
											<ImageWrapper>
												<BlogImage src={blog.imageUrl} alt={blog.title} />
												<StatsBar>
													<Stat>
														<FiMessageCircle style={{ fontSize: 18 }} />
														{blog.stats.comments}
													</Stat>
													<Stat>
														<FaRegEye style={{ fontSize: 18 }} />

														{blog.stats.views}
													</Stat>
													<Stat>
														<FaRegHeart style={{ fontSize: 18 }} />

														{blog.stats.likes}
													</Stat>
												</StatsBar>
												<TitleOverlay>{blog.title}</TitleOverlay>
												<HoverOverlay>Click to read</HoverOverlay>
											</ImageWrapper>
											<InfoRow>
												<ProfileIcon>
													<FaRegUser />
												</ProfileIcon>
												<Author>{blog.author}</Author>
												<Dot />
												<DateText>{formattedDate}</DateText>
												<Star>
													<FaRegStar />
												</Star>
											</InfoRow>
											<TitleOverlay>{blog.title}</TitleOverlay>
											<Description>{blog.description}</Description>
											<CategoryRow>
												<CategoryIcon>
													<TbCategory />
												</CategoryIcon>
												<CategoryText>{blog.category}</CategoryText>
											</CategoryRow>
										</Card>
									);
								})}
							</div>
						</div>
					</div>

					{/* RIGHT: Sticky Sidebar */}
					<aside className='w-full hidden md:block pl-5 md:w-1/3'>
						<div className='sticky top-24'>
							<BlogRightSidebar />
						</div>
					</aside>
				</div>
			</SimpleWrapper>
		</>
	);
}
